import { useGetTopologyDataQuery, useGetDataQuery } from "features/apiSlice";
import GraphContainer from "./components/GraphContainer";

function AssetTopology({
  widget,
}) {
  let getDataURL = null;
  let refreshInterval = null;
  let getCategoryDataURL = null;
  let threshold = 50;
  if (widget) {
    getDataURL = widget.getDataURL;
    refreshInterval = widget.refreshInterval ? widget.refreshInterval : 0;
    getCategoryDataURL = process.env.REACT_APP_CATEGORY_LIST_ENDPOINT;
    threshold = widget.thresholdLower || widget.thresholdUpper || 50;
  }

  const smartTopologyQuery = getDataURL
    ? useGetTopologyDataQuery(getDataURL, {
        pollingInterval: refreshInterval,
        refetchOnReconnect: true,
      })
    : {};

  const categoryListQuery = getCategoryDataURL
    ? useGetDataQuery(getCategoryDataURL)
    : {};


  return (
    <>
      <GraphContainer smartTopologyQuery={smartTopologyQuery} />
    </>
  );
}

export default AssetTopology;
